<template>
  <product-landing
    v-if="category"
    :key="$route.path"
    v-bind="category"
    class="product-landing"
  >
    <template v-if="category.introHero" #hero>
      <float v-if="useHeroWindow3d">
        <window-3d skew-left class="sm:text-lg md:text-xl lg:text-2xl">
          <sanity-media v-bind="category.introHero" no-ratio cover fluid />
        </window-3d>
      </float>
      <sanity-media
        v-else-if="category.introHero"
        :image="category.introHero.image"
        class="w-full flex items-center justify-center product-landing__hero--media"
      />
    </template>
    <template #before-grid>
      <div class="relative z-2above">
        <gradient
          :colors="[transparentColor, getColor('apricot')]"
          force-gradient
          class="absolute bottom-0 left-0 w-full h-header-height z-above pointer-events-none"
        />
      </div>
    </template>
    <template #after-grid>
      <gradient
        :colors="[getColor('apricot'), transparentColor]"
        force-gradient
        class="absolute top-0 left-0 w-full h-win-h-1/2 pointer-events-none"
      />
      <page-section
        v-if="category.introMedia"
        :cta="category.introCta"
        full-height
        centered
        class="product-landing__media"
      >
        <social-media :social-media="category.introMedia" class="container" />
      </page-section>
    </template>
  </product-landing>
</template>

<script>
import { mapGetters } from 'vuex'
import page from '~/mixins/page'
import productLanding from '~/mixins/product-landing'
import ProductLanding from '~/components/shop/products/product-landing.vue'
import SocialMedia from '~/components/social-media.vue'

export default {
  components: {
    ProductLanding,
    SocialMedia
  },

  mixins: [page, productLanding],

  data: () => ({
    category: null
  }),

  computed: {
    ...mapGetters('screen', {
      transparentColor: 'transparentColor'
    }),
    useHeroWindow3d() {
      return this.category.slug === 'realitywear'
    }
  }
}
</script>

<style>
.product-landing__media {
  --cta-background: theme('colors.titan');
  --shadow-background: theme('colors.midnight-blue');
  position: relative;
  z-index: 2;
}

.product-landing__hero--media img {
  justify-content: center;
  max-height: 20em;
  width: auto;
}

@screen md {
  .product-landing__hero--media img {
    max-height: 22em;
  }
}

@screen lg {
  .product-landing__hero--media img {
    max-height: 25em;
  }
}
</style>
